export const quickLinks = [
  { title: "About us", href: "/about-us" },
  { title: "Contact Us", href: "/contact" },
  { title: "Partner with Fydo", href: "/partner-signup" },
  { title: "Terms and Conditions", href: "/terms-and-conditions" },
  { title: "Privacy Policy", href: "/privacy-policy" },
  { title: "Refund Policy", href: "/refund-policy" },
];
